export default {
  expolreTab: state => state.app.expolreTab,
  wxjsurl: state => state.app.wxJsUrl,
  clazzShareUser: state => state.app.clazzShareUser,
  clazzShareId: state => state.app.clazzShareId,
  token: state => state.account.token,
  username: state => state.account.name,
  is_leader: state => state.account.is_leader,
  userprofile: state => state.account.profile,
  isCheckout: state => state.address.isCheckout,
  checkoutPath: state => state.address.checkoutPath,
  checkoutAddress: state => state.address.checkoutAddress,
  ossToken: state => state.upload.ossToken,
  userRaceProfile: state => state.app.userRaceProfile
}
